import { Button, ButtonProps } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({
	buttonText,
	buttonLoadingText,
	isLoading = false,
	className,
	...restProps
}) => (
	<Button
		disabled={isLoading}
		type="submit"
		className={cn(
			"w-full py-3 text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2",
			className,
		)}
		{...restProps}
	>
		{isLoading ? (
			<>
				<Loader2 className="animate-spin h-5 w-5" />
				{buttonLoadingText || buttonText}
			</>
		) : (
			buttonText
		)}
	</Button>
);

interface FormSubmitButtonProps extends ButtonProps {
	buttonText: string;
	buttonLoadingText?: string;
	isLoading?: boolean;
}
